/**
 * Route for `cr-optimization-rule-auto-action-on-cr-below-target`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CrOptimizationRuleAutoActionOnCrBelowTargetPage } from "../features/cr-optimization-rule-auto-action-on-cr-below-target/CrOptimizationRuleAutoActionOnCrBelowTargetPage";

export const crOptimizationRuleAutoActionOnCrBelowTargetRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/cr-optimization-rule-auto-action-on-cr-below-target",
	component: CrOptimizationRuleAutoActionOnCrBelowTargetPage,
});

export default crOptimizationRuleAutoActionOnCrBelowTargetRoute;
